import ActionTypes from "../actions/ActionTypes";
const initialState = {
  options: null,
  loading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SET_COMMUNICATION_HUB_OPTIONS:
      return {
        ...state,
        options: action.payload,
      };
    case ActionTypes.SET_COMMUNICATION_HUB_OPTIONS_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
}
